export default "__VITE_ASSET__BOM58o3Y__"